import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'
import { GtmService } from './gtm.service'

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    constructor(router: Router, gtm: GtmService) {
        router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            gtm.trackPageView(event.urlAfterRedirects)
        })
    }
}
